/**
 * `components.MuiTypography` — default `variant` / `variantMapping` from app typography tokens.
 * Discoverability: `MuiTypography`, `Typography`, `bodyRegular`, `variantMapping`.
 *
 * @see https://mui.com/material-ui/api/typography/
 *
 */
import type { Components, Theme } from '@mui/material/styles';
import { typographyVariantMappings } from '../createTypography';

export function muiTypography(_theme: Theme): Pick<Components<Theme>, 'MuiTypography'> {
  return {
    MuiTypography: {
      styleOverrides: {
        root: {},
      },
      defaultProps: {
        variant: 'bodyRegular',
        variantMapping: typographyVariantMappings,
      },
    },
  };
}
